module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1441648"
    }
  }, [_c('b', [_vm._v("SHRIMP COCKTAIL")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1442148"
    }
  }, [_c('b', [_c('i', [_vm._v("Everyone loves to dip shrimp into sauce; it’s fun and it’s tasty. So here are two sauces that are very different but equally delicious.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1443448"
    }
  }, [_c('b', [_vm._v("Prep: 25 minutes plus chilling "), _c('br'), _vm._v(" Cook: 17 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1444248"
    }
  }, [_vm._v("1 lemon, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1444548"
    }
  }, [_vm._v("4 bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1444848"
    }
  }, [_vm._v("20 whole black peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1445148"
    }
  }, [_vm._v("10 whole allspice berries")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1445448"
    }
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1445748"
    }
  }, [_vm._v("24 extra-large shrimp (1 pound), shelled and deveined "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c41_r1#d7e1455748"
    }
  }, [_vm._v("Southwestern-Style Cocktail Sauce")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c41_r1#d7e1460248"
    }
  }, [_vm._v("Mustard Dipping Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1447048"
    }
  }, [_vm._v("12 small romaine lettuce leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1447348"
    }
  }, [_vm._v("24 (7-inch) bamboo skewers")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1447848"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 5-quart Dutch oven, combine "), _c('i', [_vm._v("2 quarts water, ")]), _vm._v("lemon, bay leaves, peppercorns, allspice berries, and salt; heat to boiling. Cover and boil 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1449348"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Add shrimp and cook just until opaque throughout, 1 to 2 minutes. Drain and rinse with cold running water to stop cooking. Cover and refrigerate shrimp up to 24 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1451048"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Prepare Southwestern-Style Cocktail Sauce and/or Mustard Dipping Sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1452148"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Just before serving, place bowls of sauces in center of platter; arrange romaine leaves around bowls, leaf tips facing out. Thread each shrimp on a bamboo skewer and arrange skewers on romaine. Makes 8 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1454448"
    }
  }, [_vm._v("Each serving without sauce: About 51 calories, 10g protein, 1g carbohydrate, 1g total fat (0g saturated), 70mg cholesterol, 141mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1455748"
    }
  }, [_c('b', [_vm._v("SOUTHWESTERN-STYLE COCKTAIL SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e1456248"
    }
  }, [_vm._v("In bowl, stir "), _c('b', [_vm._v("1 cup bottled cocktail sauce, 2 tablespoons chopped fresh cilantro, 2 teaspoons minced jalapeño chile, ")]), _vm._v("and "), _c('b', [_vm._v("2 teaspoons fresh lime juice ")]), _vm._v("until well combined. Cover and refrigerate up to 24 hours. Makes about 1 cup.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1459248"
    }
  }, [_vm._v("Each tablespoon: About 18 calories, 0g protein, 4g carbohydrate, 0g total fat (0g saturated), 0mg cholesterol, 191mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1460248"
    }
  }, [_c('b', [_vm._v("MUSTARD DIPPING SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e1460748"
    }
  }, [_vm._v("In small serving bowl, stir "), _c('b', [_vm._v("1 cup reduced-fat sour cream, 3 tablespoons grainy Dijon mustard, 3 tablespoons chopped fresh parsley, ¼ teaspoon freshly grated lemon peel, ¼ teaspoon salt, ")]), _vm._v("and "), _c('b', [_vm._v("⅛ teaspoon coarsely ground black pepper ")]), _vm._v("until well combined. Cover and refrigerate up to 24 hours. Makes about 1 cup.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1466748"
    }
  }, [_vm._v("Each tablespoon: About 28 calories, 1g protein, 1g carbohydrate, 2g total fat (1g saturated), 5mg cholesterol, 111mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60f434e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c41_r1.vue
// module id = 189
// module chunks = 0